import { UniversalUserSelectionType } from '../../../../../types';

export const mapToUniversalUserSelectionType = ({
  id,
  full_name,
  usercompany_id,
}: {
  id: number;
  full_name: string;
  usercompany_id?: number;
}): UniversalUserSelectionType => {
  return { id, label: full_name, usercompany_id };
};
